import React, {useState} from 'react';
import {Flex, Stack} from '@chakra-ui/react';
import {PanoUnloadButton} from './PanoUnloadButton';
import PanoToastFoundNew360 from './PanoToastFoundNew360';
import PanoToastSaveForm from './PanoToastSaveForm';

const PanoToastContent = ({}) => {

  const [showDialog, setShowDialog] = useState(true);
  const [showSaveForm, setShowSaveForm] = useState(false);

  return (
    <Flex
      alignItems="start"
      gap={3}
      w="full"
    >
      <PanoUnloadButton/>

      {showDialog && (
        <Stack>
          {showSaveForm &&
            <PanoToastSaveForm
              onCloseClick={() => setShowDialog(false)}
            />}

          {!showSaveForm &&
            <PanoToastFoundNew360
              onCloseClick={() => setShowDialog(false)}
              onSaveButtonClick={() => setShowSaveForm(true)}
            />}

        </Stack>
      )}
    </Flex>
  );
};

export default PanoToastContent;